import { useSelector } from 'react-redux';

// Components
import Main from 'components/common/Layout/Main';
import DemoContent from 'components/templates/demo';
import Container from 'components/common/Layout/Container';

// Libs and configs
import Translation from 'libs/Translation';
import { appConfig, apiConfig } from 'configs';

const Demo = ({ faqList = [] }) => {
    const {webConfig} = useSelector(state => state.core);

    const title = Translation.t('title.doctors-experience');
	const description = Translation.t('text.vclinic-doctors-experience');

	const breadCrumb = {
		itemListElements: [
			{
				position: 1,
				name: Translation.t('title.default'),
				item: 'https://vclinic.io',
			},
			{
				position: 2,
				name: Translation.t('title.doctors-experience'),
				item: `https://vclinic.io/register`,
			},
		],
	};

	const seo = {
		title: `${title} | ${Translation.t('title.default')}`,
		description: description,
		h1Title: title,
		additionalMetaTags: [],
	};

    return (
        <Main breadCrumb={breadCrumb} seo={seo}>
            <Container>
                <DemoContent 
					webConfig={webConfig}
					faqList={faqList} 
				/>
            </Container>
        </Main>
    )
}

export default Demo;

export const getServerSideProps = async ({ query }) => {
	let result;
	let data;

	let lang = 'fa';
	if (query.lang) {
		lang = query.lang
	}

	try {
		result = await Promise.all([
			fetch(`${appConfig.node_api_base_url}${apiConfig.getFAQ.endpoint}?lang=${lang}&page=/register`)
		]);

		if (result) {
			data = await Promise.all([
				result[0].json(),
			]);
		}
	}
	catch (error) {
		console.error(error)
	}

	return {
		props: {
			faqList: data[0]?.length ? data[0][0]?.FAQ : []
		},
	};
};